export function setUserProfessions(professions, userId) {
  return {
    endpoint: `users/${userId}/professions`,
    method: 'POST',
    data: professions,
    requireAuth: true,
    convertApiErrorsToReduxFormErrors: true,
  };
}



// WEBPACK FOOTER //
// ./src/api/config/professions.js